import { EventItemNew } from "./EventItemNew";

export default EventItemNew;
